import React, { Component } from "react";
import ReactDOM from "react-dom";
import $ from "jquery";
import {OverlayTrigger, Tooltip} from 'react-bootstrap';

// TODO: limpiar los self

export class ActiveMap extends Component {
  imgw: 0
  imgh: 0
  imgnw: 0
  imgnh: 0
  left: 0
  over: null

  render() {
    var rw = this.imgnw > 0 ? this.imgw/this.imgnw : 0;
    var rh = this.imgnh > 0 ? this.imgh/this.imgnh : 0;
    var self = this;
    var canvas =
        <svg className="activemap" width={this.imgw} height={this.imgh} style={{position: "absolute", left: this.left, top: "0px", opacity: "1"}}
           onClick={function(ev) {if(self.props.onClick) {
                      var pos = $(self.refs.img).offset();
                      self.props.onClick((ev.pageX-pos.left)/rw, (ev.pageY-pos.top)/rh);}}}
           onMouseMove={function(ev) {if(self.props.onMouseMove) {
                      var pos = $(self.refs.img).offset();
                      self.props.onMouseMove((ev.pageX-pos.left)/rw, (ev.pageY-pos.top)/rh);}}}
           >
           {this.props.areas.map(function(area){
             var r = null;
             var r2 = null;
             var coords = null;
             var cx = null;
             var cy = null;

             var hover = (self.over == area) || (self.props.area == area.name);

             if (area.shape == "circle") {
               coords = area.coords.split(",");
               r = <ellipse cx={coords[0]*rw} cy={coords[1]*rh}
                            rx={coords[2]*rw} ry={coords[2]*rh}
                            style={{fillOpacity: hover ? 0.7 : 0.4}}
                            />;
               cx = coords[0]*rw;
               cy = coords[1]*rh;
               if (area.id==203) {
                 }
             } else if (area.shape == "poly") {
               coords = area.coords.split(",");
               var coords2 = [];
               var mx = coords[0]*rw, Mx = coords[0]*rw, my = coords[1]*rh, My = coords[1]*rh;
               for (var i=0;i<coords.length/2;i++) {
                 var x = coords[2*i]*rw, y = coords[2*i+1]*rh;

                 coords2[i] = x+","+y+" ";
                 if (x < mx) mx=x;
                 if (x > Mx) Mx=x;
                 if (y < my) my=y;
                 if (y > My) My=y;
                 }
               r = <polygon points={coords2} style={{fillOpacity: hover ? 0.7 : 0.4}}/>
               cx = (mx+Mx)/2;
               cy = (my+My)/2;
             } else {
               return null;
               }
             if (hover) {
               r2 = <g><rect x={cx-12} y={cy-15} width={area.name.length * 7+20} height="25" />
                       <text x={cx} y={cy} fill="white">{area.name}</text></g>;
               }
             return(<g key={area.name}
                     onMouseEnter={function() {self.over = area;self.forceUpdate();}}
                     onMouseLeave={function() {if (self.over == area) {self.over = null;self.forceUpdate();}}}
                     onClick={self.props.onselect && function() {self.props.onselect(area.id);}}
                     >{r}{r2}</g>);
           })}
        </svg>
        ;
    return(
      <div style={{position: "relative"}}>
        <img src={this.props.src} width="100%" ref="img" onLoad={this.recalc_size.bind(this)}/>
        {canvas}
      </div>
      );
    }
  componentDidMount() {
      window.addEventListener("resize", this.recalc_size.bind(this));
      this.recalc_size();
    }
  recalc_size() {
        if (this.refs && this.refs.img) {
          var img = this.refs.img;
          this.imgw = img.width;
          this.imgh = img.height;
          this.imgnw = img.naturalWidth;
          this.imgnh = img.naturalHeight;
          this.left = img.offsetLeft;
          this.forceUpdate();
          }
    }
  componentWillUnmount() {
      window.removeEventListener("resize", this.recalc_size);
    }
};
